import { render } from "./CollectPayments.vue?vue&type=template&id=18879265&scoped=true"
import script from "./CollectPayments.vue?vue&type=script&lang=js"
export * from "./CollectPayments.vue?vue&type=script&lang=js"

import "./CollectPayments.vue?vue&type=style&index=0&id=18879265&scoped=true&lang=css"
import "./CollectPayments.vue?vue&type=style&index=1&id=18879265&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18879265"]])

export default __exports__